import { useEffect, useState } from 'react'

/**
 * Stable object URL for a File; revokes on file change or unmount.
 * Avoids storing large base64 strings in React state / react-hook-form.
 */
export function useObjectUrlForFile(
  file: File | null | undefined
): string | null {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!file) {
      setUrl(null)
      return
    }
    const objectUrl = URL.createObjectURL(file)
    setUrl(objectUrl)
    return () => {
      URL.revokeObjectURL(objectUrl)
    }
  }, [file])

  return url
}
